import { css } from "@emotion/react";
import styled from "@emotion/styled";

import ActionPanel from "~/components/database/detail/database-content/database-header/pc/ActionPanel";
import Title from "~/components/database/detail/database-content/database-header/pc/CategoryAndTitle";
import DatabaseMetaInfo from "~/components/database/detail/database-content/database-header/pc/DatabaseMetaInfo";
import DescriptionAndCategory from "~/components/database/detail/database-content/database-header/pc/Description";
import WriteButton from "~/components/database/detail/database-content/database-header/pc/WriteButton";
import { fixedHeight } from "~/lib/client/design";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

type Props = {
  openModal: () => void;
  form: DatabaseDetailPageProps["form"];
};

const PcDatabaseHeader = (props: Props) => {
  return (
    <div css={rootStyle}>
      <div css={headerUpperContainerStyle}>
        <div css={actionPanelContainerStyle}>
          <ActionPanel form={props.form} />
        </div>
        <TitleAndDescriptionContainer>
          <Title form={props.form} />
          <DescriptionAndCategory form={props.form} />
        </TitleAndDescriptionContainer>
      </div>
      <div css={headerDownContainerStyle}>
        <WriteButton openModal={props.openModal} />
        <DatabaseMetaInfo form={props.form} />
      </div>
    </div>
  );
};

const rootStyle = css`
  width: 100%;
`;

const headerUpperContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const actionPanelContainerStyle = css`
  border-right: 1px solid #ccc;
`;

const headerDownContainerStyle = css`
  ${fixedHeight("2.5rem")};
  width: 100%;
  display: flex;
  flex-direction: row;
  position: sticky;
  top: 0;
`;

const TitleAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export { PcDatabaseHeader };
